import React, { useCallback, useState, createContext, useContext } from 'react';
interface UpsellContextValue {
  openUpsell: () => void;
}
const UpsellContext = createContext<UpsellContextValue | null>(null);
export function useUpsell() {
  const ctx = useContext(UpsellContext);
  if (!ctx) {
    throw new Error('useUpsell must be used within UpsellProvider');
  }
  return ctx;
}
interface UpsellProviderProps {
  children: React.ReactNode;
  onOpen: () => void;
}
export function UpsellProvider({
  children,
  onOpen
}: UpsellProviderProps) {
  const openUpsell = useCallback(() => {
    onOpen();
  }, [onOpen]);
  return <UpsellContext.Provider value={{
    openUpsell
  }} data-id="element-268">
      {children}
    </UpsellContext.Provider>;
}